if (!customElements.get('brazur-gallery')) {
  customElements.define('brazur-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.bz-track');
      const thumbs = this.querySelector('.bz-thumbs');
      const photos = [...track.querySelectorAll(':scope > figure')];
      const dialog = this.querySelector('dialog');
      const zoom = dialog.querySelector('img');
      const select = index => track.scrollTo({left: photos[index].offsetLeft - photos[0].offsetLeft, behavior:'instant'});
      const buttons = photos.map((photo,index) => {
        const img = photo.querySelector('img');
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Photo ${index+1} — ${img.alt || 'Bijou'}`);
        button.setAttribute('aria-pressed', String(index === 0));
        const preview = document.createElement('img');
        preview.src = img.currentSrc || img.src;
        preview.alt = '';
        preview.loading = 'lazy';
        button.append(preview);
        button.addEventListener('click', () => select(index));
        thumbs.append(button);
        img.tabIndex = 0;
        img.setAttribute('role','button');
        img.setAttribute('aria-label', `Agrandir — ${img.alt || 'Photo du bijou'}`);
        const open = () => { zoom.src = img.src; zoom.alt = img.alt; dialog.showModal(); };
        img.addEventListener('click',open);
        img.addEventListener('keydown', e => { if(e.key === 'Enter' || e.key === ' ') {e.preventDefault();open();} });
        return button;
      });
      const activeIndex = () => Math.max(0, Math.min(photos.length-1,Math.round(track.scrollLeft / track.clientWidth)));
      track.addEventListener('scroll', () => buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===activeIndex()))),{passive:true});
      track.addEventListener('keydown', e => {
        if(e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); select(Math.max(0,Math.min(photos.length-1,activeIndex()+(e.key==='ArrowRight'?1:-1)))); }
      });
      dialog.querySelector('button').addEventListener('click',()=>dialog.close());
      this.classList.add('bz-ready');
      this.closest('media-gallery').classList.add('bz-enhanced');
    }
  });
}
